module.exports = __webpack_public_path__ + "static/tyre-icon-ebe0f322509353d0b2524fdfdbb251c3.png";